/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Mission Operation component step 2 of the input form
Author: Deimos Space UK

Version: 1.0
*/
import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Card } from 'react-bootstrap';
import SpacecraftDesign from './SpacecraftDesign/SpacecraftDesign';
import MissionOperationForm from './MissionOperationForm/MissionOperationForm';
import PropulsionTechnology from './PropulsionTechnology/PropulsionTechnology';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { useLocation } from 'react-router-dom';

export default function MissionOperation(props) {
  const [architectureType, setArchitectureType] = useState('')
  const [orbits, setNOrbits] = useState(0)
  const [step2, setStep2] = useState([])
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const data = sessionStorage.getItem('firstStep');
    if (data) {
      setLoading(false)
      const step1 = JSON.parse(data);
      setArchitectureType(step1.architectureType)
      if (step1.architectureType === 'constellation') {
        setNOrbits(parseInt(step1.nOrbits))
      } else {
        setNOrbits(1)
      }
      setLoading(true)
    }
  }, [])

  useEffect(() => {
    if (props.id) {
        if(location.pathname.includes('clone')){
            setDisabled(false)
        }else{
            setDisabled(true)
        }
    }
}, [props.id, location.pathname])

  const nextStep = () => {
    sessionStorage.setItem('secondStep', JSON.stringify(step2))
    props.handleNext()
  }



  useEffect(() => {
    setLoading(false)
    const nOrbits = []
    const data = sessionStorage.getItem('secondStep');
    if (data) {
      const step2 = JSON.parse(data);
      setStep2(step2)
    } else {

      for (let i = 0; i < orbits; i++) {
        let newStep2 = {
          id: i,
          SpacecraftDesign: {
            mass: '',
            cross: '',
            objectType: '',
          },
          MissionOperation: {
            cam: '',
            camStatus: 'active',
            debrisTrackability: '',
            acpl: '',
            cam_efficacy: '',
            pmdSuccessRate: '',
          },
          PropulsionTechnology: {
            propulsionTechnology: '',
            specificImpulse: '',
            maximumThrust: '',
            thrustLifetime: '',
            mass: '',
            effectiveSailArea: '',
            propulsionTechnologySubtype: '',
          },
        }
        nOrbits.push(newStep2)
      }
      setStep2(nOrbits)
    }
    setLoading(true)
  }, [orbits])

  const onChangePropulsionTechnology = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.propulsionTechnology = value
    newStep2[index].PropulsionTechnology.specificImpulse = ''
    newStep2[index].PropulsionTechnology.maximumThrust = ''
    newStep2[index].PropulsionTechnology.thrustLifetime = ''
    newStep2[index].PropulsionTechnology.mass = ''
    newStep2[index].PropulsionTechnology.effectiveSailArea = ''
    newStep2[index].PropulsionTechnology.propulsionTechnologySubtype = ''
    setStep2(newStep2)
  }

  const onChangeSpecificImpulse = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.specificImpulse = value
    setStep2(newStep2)
  }

  const onChangeMaximumThrust = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.maximumThrust = value
    setStep2(newStep2)
  }

  const onChangeThrustLifetime = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.thrustLifetime = value
    setStep2(newStep2)
  }

  const onChangeMassPropulsion = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.mass = value
    setStep2(newStep2)
  }

  const onChangeEffectiveSailArea = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.effectiveSailArea = value
    setStep2(newStep2)
  }

  const onChangePropulsionTechnologySubtype = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].PropulsionTechnology.propulsionTechnologySubtype = value
    setStep2(newStep2)
  }

  const onChangeMass = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].SpacecraftDesign.mass = value
    setStep2(newStep2)

  }

  const onChangeCross = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].SpacecraftDesign.cross = value
    setStep2(newStep2)
  }

  const onChangeObjectType = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].SpacecraftDesign.objectType = value
    setStep2(newStep2)
  }

  const onChangeCamEfficacy = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].MissionOperation.cam = value
    if (value === 'no') {
      newStep2[index].MissionOperation.debrisTrackability = 'Constant'
      newStep2[index].MissionOperation.acpl = '0.00001'
      newStep2[index].MissionOperation.cam_efficacy = ''
    }
    setStep2(newStep2)
  }

  const onChangeCamStatus = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].MissionOperation.camStatus = value
    setStep2(newStep2)
  }

  const onChangeDebrisTrackability = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].MissionOperation.debrisTrackability = value
    setStep2(newStep2)
  }

  const onChangeAcpl = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].MissionOperation.acpl = value
    setStep2(newStep2)
  }

  const onChangeEfficacy = (value, index) => {
    const newStep2 = [...step2]
    newStep2[index].MissionOperation.cam_efficacy = value
    setStep2(newStep2)
  }

  const onChangePmdSuccessRate = (value, index) => {
    const newStep2 = [...step2]
    if (newStep2[index]) {
      newStep2[index].MissionOperation.pmdSuccessRate = value
      setStep2(newStep2)
    }
  }

  const validateForm = () => {
    let valid = true
    if (props.id && !location.pathname.includes('clone' )) {
      return false
    }
    if(architectureType=== 'launcher'){
      return false
    }
    step2.forEach((value, index) => {
      if (value.SpacecraftDesign.mass === '' ||
        value.SpacecraftDesign.cross === '' ||
        value.PropulsionTechnology.propulsionTechnology === '' ||
        value.MissionOperation.cam === '' ||
        value.MissionOperation.pmdSuccessRate === '' ||
        value.SpacecraftDesign.objectType === ''
      ) {
        valid = false
      }
      if (value.MissionOperation.cam === 'yes') {
        if (value.MissionOperation.debrisTrackability === '') {
          valid = false
        }
        if (value.MissionOperation.cam_efficacy === '' && value.MissionOperation.acpl === '') {
          valid = false
        }
      }

    })

    return !valid
  }

  const duplicateOrbit = () => {
    const newStep2 = [...step2]
    const spacecraftDesign = JSON.stringify(newStep2[0].SpacecraftDesign)
    const propulsionTechnology = JSON.stringify(newStep2[0].PropulsionTechnology)
    const missionOperation = JSON.stringify(newStep2[0].MissionOperation)
    if (step2[0]) {
      for (let i = 1; i < orbits; i++) {
        newStep2[i] = {
          SpacecraftDesign: JSON.parse(spacecraftDesign),
          PropulsionTechnology: JSON.parse(propulsionTechnology),
          MissionOperation: JSON.parse(missionOperation)
        }
        setStep2(newStep2)
      }
    }

  }

  function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    return (
      <button
        type="button"
        style={{ backgroundColor: 'white', border: 'none', width: '100%', textAlign: 'left', margin: 0 }}
        onClick={decoratedOnClick}
      >
        {children}
      </button>
    );
  }

  const disabledGetFromAres = (index) => {
    const newStep2 = [...step2]
    if (newStep2[index] && newStep2[index].MissionOperation.cam === 'yes' &&
      newStep2[index].MissionOperation.camStatus === 'active') {
      return false
    }
    return true
  }

  if (!loading) {
    return null
  }

  return (
    <div style={{ width: '100%' }}>
      {orbits > 1 && (
        <Row >
          <Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Button style={{ background: '#003247' }} onClick={() => duplicateOrbit()}>Copy plane data</Button>
          </Col>
        </Row>
      )}

      {
        [
          ...Array(orbits),
        ].map((value, index) => (
          <Accordion defaultActiveKey={index}>
            <Accordion.Item eventKey={index}>
              <Row style={{ marginBottom: '15px', paddingBottom: '30px' }} key={`${index}`}>
                {architectureType === 'constellation' &&

                  <Col xs={12}>
                    <Card.Header style={{ color: 'white', padding: '0', }}>
                      <CustomToggle eventKey={index}>
                        <h1 style={{ color: '#003247' }}>Plane {index + 1}</h1>

                      </CustomToggle>

                    </Card.Header>
                  </Col>

                }
                <Accordion.Body style={{ padding: '20px' }}>
                  <Row>
                    <Col xs={12} >
                      <Row>
                        <Col xs={12}>
                          <SpacecraftDesign
                            index={index}
                            step2={step2}
                            onChangeMass={onChangeMass}
                            onChangeCross={onChangeCross}
                            onChangeObjectType={onChangeObjectType}
                            disabled={disabled}
                            architectureType={architectureType}
                          />
                        </Col>
                        {
                          architectureType !== 'launcher' &&

                          <Col xs={12}>
                            <PropulsionTechnology
                              index={index}
                              disabled={disabled}
                              step2={step2}
                              onChangePropulsionTechnology={onChangePropulsionTechnology}
                              onChangeSpecificImpulse={onChangeSpecificImpulse}
                              onChangeMaximumThrust={onChangeMaximumThrust}
                              onChangeThrustLifetime={onChangeThrustLifetime}
                              onChangeMassPropulsion={onChangeMassPropulsion}
                              onChangeEffectiveSailArea={onChangeEffectiveSailArea}
                              onChangePropulsionTechnologySubtype={onChangePropulsionTechnologySubtype}
                            />
                          </Col>
                        }
                      </Row>

                    </Col>
                    <Col xs={12} >
                      <MissionOperationForm
                        index={index}
                        disabled={disabled}
                        step2={step2}
                        onChangeCamEfficacy={onChangeCamEfficacy}
                        onChangeStatus={onChangeCamStatus}
                        onChangeDebrisTrackability={onChangeDebrisTrackability}
                        onChangeAcpl={onChangeAcpl}
                        onChangeEfficacy={onChangeEfficacy}
                        onChangePmdSuccessRate={onChangePmdSuccessRate}
                        disabledGetFromAres={disabledGetFromAres}
                        architectureType={architectureType}
                      />
                    </Col>
                  </Row>
                </Accordion.Body>
              </Row>
            </Accordion.Item>
          </Accordion>
        ))
      }

      <Row>
        <Col xs={12}>
          <div style={{ paddingTop: '20px', paddingBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button style={{ background: '#003247', borderColor: '#003247' }} onClick={props.handleBack}>
              Previous
            </Button>
            <Button disabled={validateForm()} style={{ background: '#003247', borderColor: '#003247' }} onClick={nextStep}>
              Next
            </Button>
          </div>
        </Col>
      </Row>
    </div>

  )
}
